import { useEffect, useState } from 'react'

/**
 * BUG-099: OAuth popup landing route for the LinkedIn "Connect" flow.
 *
 * ExpertiseRegistration opens LinkedIn's authorize page in a popup with
 * redirect_uri = {origin}/auth/linkedin/callback and listens for a
 * 'linkedin-callback' postMessage. This route previously did not exist (the
 * catch-all redirected to '/'), so no message was ever produced and the
 * Connect flow could never complete. This component relays the OAuth result
 * to the opener and closes itself.
 */
export default function LinkedInCallback() {
  const [noOpener, setNoOpener] = useState(false)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const code = params.get('code')
    const error = params.get('error') || params.get('error_description')
    const opener: Window | null = window.opener
    if (opener) {
      // Same-origin target only — never broadcast the auth code with '*'.
      opener.postMessage({ type: 'linkedin-callback', code, error }, window.location.origin)
      window.close()
    } else {
      setNoOpener(true)
    }
  }, [])

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#E8EFF4] px-4">
      <p className="text-sm text-[#0C4A6E] text-center max-w-md">
        {noOpener
          ? 'LinkedIn sign-in finished, but the window that started it is gone. Close this tab and click "Connect LinkedIn" again.'
          : 'Completing LinkedIn sign-in… this window will close itself.'}
      </p>
    </div>
  )
}
